<script setup lang="ts">
import { computed } from 'vue';
import { useFavoritesStore } from '~/stores/favorites-store';
import { useUserStore } from '~/stores/user-store';
import type { Project } from '~/utilities/pyscript-api-models';
import IconStar from '~icons/carbon/star';
import IconStarFilled from '~icons/carbon/star-filled';

const props = withDefaults(
  defineProps<{
    project: Project;
    size: 'sm' | 'md' | 'lg';
  }>(),
  {
    size: 'md',
  },
);

const userStore = useUserStore();
const favoritesStore = useFavoritesStore();
const isFavorite = computed(() => favoritesStore.isFavorite(props.project.id));

const lg = 'text-base h-8 w-8';
const md = 'text-sm h-7 w-7';
const sm = 'text-xs h-6 w-6';

function onFavoriteClick() {
  if (isFavorite.value) {
    favoritesStore.removeFavorite(props.project.id);
  } else {
    favoritesStore.addFavorite(props.project);
  }
}
</script>

<template>
  <button
    v-if="userStore.isLoggedIn"
    :class="{ [lg]: size === 'lg', [md]: size === 'md', [sm]: size === 'sm' }"
    class="group flex items-center justify-center rounded-full text-new-gray-800 transition-colors hover:bg-new-gray-100/50 dark:text-new-gray-100"
    @click="onFavoriteClick"
  >
    <IconStarFilled
      v-if="isFavorite"
      v-tooltip="{ content: 'Unfavorite' }"
      class="shrink-0 text-yellow-500"
    />
    <IconStar
      v-else
      v-tooltip="{ content: 'Favorite' }"
      class="shrink-0 text-new-gray-400 transition-colors group-hover:text-slate-600 dark:group-hover:text-slate-100"
    />
  </button>
</template>

<style scoped lang="postcss"></style>
